import { set, unset } from 'cerebral/operators'
import redirect from 'cerebral-module-router/redirect'
import checkIsAdmin from '../actions/checkIsAdmin'
import setAdminClientHelperForCurrentUser
  from '../actions/setAdminClientHelperForCurrentUser'
import setDataLoading from '../actions/setDataLoading'
import setDataUnloading from '../actions/setDataUnloading'
import closeNavigation from './closeNavigation'
import resetAllForms from '../factories/resetAllForms'
import validateAllForms from '../factories/validateAllForms'
import isPreventAllClientFields from '../factories/isPreventAllClientFields'
import makeFieldRequired from '../factories/makeFieldRequired'
import prepareModuleFieldsForNewUser
  from '../actions/prepareModuleFieldsForNewUser'
import resetSelectedOptions from '../actions/resetSelectedOptions'
import isRemoteLogin from '../../client/actions/isRemoteLogin'
import setLocaleForCurrentUser from '../actions/setLocaleForCurrentUser'
import initializeFields from 'modules/app/chains/initializeFields'

export default [
  setDataLoading,
  checkIsAdmin,
  {
    false: [redirect('/login')],
    true: [
      unset('state:client.currentUser'),
      setAdminClientHelperForCurrentUser,
      isPreventAllClientFields(false),
      validateAllForms(), // this shouldn't be needed but mobile does not repaint!
      resetSelectedOptions,
      resetAllForms(),
      ...initializeFields,
      setLocaleForCurrentUser,
      isRemoteLogin,
      {
        true: [],
        false: [
          makeFieldRequired(
            'client.registrating.current.newPassword.password',
            true
          ),
          makeFieldRequired(
            'client.registrating.current.newPassword.confirmPassword',
            true
          )
        ]
      },
      prepareModuleFieldsForNewUser,
      setDataUnloading,
      ...closeNavigation,
      set('state:client.currentPage', 'users/add')
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/prepareNewUser.js